import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from 'react'
import AppContext from '../../appContext'
import Dialog from '../../components/Dialog'
import QCMapPanel from '../../components/QCMapPanel'
import {SamplePoint} from '../../components/GeoMap'
import SampleDataOverlay from '../../components/SampleDataOverlay'
import {RowWithId} from './limeSoilUtils'

interface SampleLocationsDialogProps {
    show: boolean
    setShow: Dispatch<SetStateAction<boolean>>
    rows: RowWithId[]
    samplePoints: SamplePoint[]
    boundaryCoordinates: Array<{x: number; y: number}>
    boundaryLoading: boolean
    boundaryError: boolean
    landId?: number
    meq100gMode: boolean
}

const SampleLocationsDialog: React.FC<SampleLocationsDialogProps> = (props) => {
    const app = useContext(AppContext)
    const system = app.initial.system
    const [selectedLabel, setSelectedLabel] = useState<string | null>(null)

    useEffect(() => {
        if (!props.show) setSelectedLabel(null)
    }, [props.show])

    const selectedRow = selectedLabel ? props.rows.find(r => (r.referenceNr || r.landRef) === selectedLabel) : null

    return (
        <Dialog
            title={app.word('sample_locations')}
            show={props.show}
            setShow={props.setShow}
            body={
                <div className="p-4 min-w-[70vw]">
                    {props.boundaryLoading ? (
                        <div className="flex items-center justify-center h-[60vh] bg-gray-100 rounded">
                            <div className="text-gray-500">{app.word('loading')}...</div>
                        </div>
                    ) : (
                        <QCMapPanel
                            samplePoints={props.samplePoints}
                            boundaryCoordinates={props.boundaryCoordinates}
                            boundaryError={props.boundaryError}
                            landId={props.landId}
                            selectedPointLabel={selectedLabel}
                            onPointSelect={setSelectedLabel}
                        >
                            {selectedRow && (
                                <SampleDataOverlay
                                    row={selectedRow}
                                    meq100gMode={props.meq100gMode}
                                    system={system}
                                />
                            )}
                        </QCMapPanel>
                    )}
                    <div className="flex justify-end">
                        <button
                            className="btn-sm bg-primary"
                            onClick={() => props.setShow(false)}
                        >
                            {app.word('done')}
                        </button>
                    </div>
                </div>
            }
        />
    )
}

export default SampleLocationsDialog
